/* SLOVENŠTINA PRO NASTAVENÍ REZERVACÍ „JAKO CALENDLY“ (19. 10. 2026) — klíčem je ČESKÝ TEXT.
 * Mechanismus jako data/prekladyUI.diarTymNabor.data.js; samostatný soubor, protože
 * oba slovníky souběžně mění jiné týmy. Slučuje lib/prekladyUI.js (velký má přednost).
 * ⚠️ ŽÁDNÉ ASCII uvozovky uvnitř textu (CLAUDE.md, pravidlo 1).
 */
export const PREKLADY_REZERVACE = {
  "Rezervace schůzky": { sk: "Rezervácia stretnutia" },
  "QR kód se nepodařilo vytvořit": { sk: "QR kód sa nepodarilo vytvoriť" },
  "Pauza před schůzkou (min)": { sk: "Pauza pred stretnutím (min)" },
  "Pauza po schůzce (min)": { sk: "Pauza po stretnutí (min)" },
  "Max. schůzek za den": { sk: "Max. stretnutí za deň" },
  "0 = bez limitu": { sk: "0 = bez limitu" },
  "Státní svátky volno": { sk: "Štátne sviatky voľno" },
  "Polední pauza": { sk: "Obedňajšia pauza" },
  "Pauza od": { sk: "Pauza od" },
  "Pauza do": { sk: "Pauza do" },
  "Dovolená a výjimky": { sk: "Dovolenka a výnimky" },
  "Od": { sk: "Od" },
  "Do": { sk: "Do" },
  "Typ výjimky": { sk: "Typ výnimky" },
  "Celý den volno": { sk: "Celý deň voľno" },
  "Jiná pracovní doba": { sk: "Iný pracovný čas" },
  "Poznámka (jen pro vás)": { sk: "Poznámka (len pre vás)" },
  "Smazat výjimku": { sk: "Zmazať výnimku" },
  "Přidat dovolenou nebo výjimku": { sk: "Pridať dovolenku alebo výnimku" },
  "Otázky ve formuláři": { sk: "Otázky vo formulári" },
  "Jméno, e-mail a telefon se ptá vždy. Tady přidáte vlastní — odpovědi uvidíte v diáři u schůzky.": {
    sk: "Meno, e-mail a telefón sa pýta vždy. Tu pridáte vlastné — odpovede uvidíte v diári pri stretnutí.",
  },
  "Text otázky": { sk: "Text otázky" },
  "Možnosti oddělené čárkou (nepovinné)": { sk: "Možnosti oddelené čiarkou (nepovinné)" },
  "Povinná": { sk: "Povinná" },
  "Smazat otázku": { sk: "Zmazať otázku" },
  "Co chcete na schůzce řešit?": { sk: "Čo chcete na stretnutí riešiť?" },
  "Hypotéka": { sk: "Hypotéka" },
  "Investice": { sk: "Investície" },
  "Pojištění": { sk: "Poistenie" },
  "Penze": { sk: "Dôchodok" },
  "Přidat otázku": { sk: "Pridať otázku" },
  "Vložit na vlastní web": { sk: "Vložiť na vlastný web" },
  "Kód pro vložení": { sk: "Kód na vloženie" },
  "Kopírovat kód": { sk: "Kopírovať kód" },
  "QR kód odkazu": { sk: "QR kód odkazu" },
  "Odkud rezervace přišla, poznáte přidáním ?zdroj= na konec odkazu (např. ?zdroj=instagram).": {
    sk: "Odkiaľ rezervácia prišla, zistíte pridaním ?zdroj= na koniec odkazu (napr. ?zdroj=instagram).",
  },
  "QR kód rezervačního odkazu": { sk: "QR kód rezervačného odkazu" },
  "E-maily k rezervacím (potvrzení, připomínky 24 h a 1 h předem, zrušení) se pošlou po napojení e-mailové služby. Do té doby čekají ve frontě, nic se neztratí.": {
    sk: "E-maily k rezerváciám (potvrdenie, pripomienky 24 h a 1 h vopred, zrušenie) sa pošlú po napojení e-mailovej služby. Dovtedy čakajú vo fronte, nič sa nestratí.",
  },
  "Čeká: {n}": { sk: "Čaká: {n}" },
  "Zrušeno": { sk: "Zrušené" },
  "Zrušit schůzku s {jmeno}? Klient dostane e-mail.": { sk: "Zrušiť stretnutie s {jmeno}? Klient dostane e-mail." },
  "Schůzka je zrušená": { sk: "Stretnutie je zrušené" },
  "Nelze zrušit": { sk: "Nedá sa zrušiť" },
  "Zrušit": { sk: "Zrušiť" },
  /* 24. 10. 2026 — doplněno při velkém testu SK (chyběly). */
  "Jméno, e-mail a telefon se ptá vždy. Tady přidáte vlastní — odpovědi uvidíte v diáři u schůzky.": { sk: "Meno, e-mail a telefón sa pýtame vždy. Tu pridáte vlastné — odpovede uvidíte v diári pri stretnutí." },
  "Odkud rezervace přišla, poznáte přidáním ?zdroj= na konec odkazu (např. ?zdroj=instagram).": { sk: "Odkiaľ rezervácia prišla, zistíte pridaním ?zdroj= na koniec odkazu (napr. ?zdroj=instagram)." },
  "E-maily k rezervacím (potvrzení, připomínky 24 h a 1 h předem, zrušení) se pošlou po napojení e-mailové služby. Do té doby čekají ve frontě, nic se neztratí.": { sk: "E-maily k rezerváciám (potvrdenie, pripomienky 24 h a 1 h vopred, zrušenie) sa odošlú po napojení e-mailovej služby. Dovtedy čakajú vo fronte, nič sa nestratí." },
};
